import { apiCallsDashboard } from '../api/calls/dashboard';
import { useState, useEffect } from "react";

export const useDashboard = (filters) => {
    const [countDevices, setCountDevices] = useState([]);
    const [totalConsumptions, setTotalConsumptions] = useState({});
    const [latestPayloads, setLatestPayloads] = useState([]);
    const [gateways, setGateways] = useState([]);
    const [gatewaysInfo, setGatewaysInfo] = useState({});
    const [gatewaysStatus, setGatewaysStatus] = useState([]);
    const [devicesStates, setDevicesStates] = useState([]);

    const getCountsDevices = async () => {
      const result = await apiCallsDashboard.Actions.GetCountsDevices();
      setCountDevices(result);
      const active = result.all - result.error;
      const off = result.error;
      setDevicesStates([active, off]);
    };

    const getTotalConsumptionForNEMAAndPillars = async (filters) => {
      try {
        const result = await apiCallsDashboard.Actions.GetTotalConsumptionForNEMAAndPillars(filters);
        setTotalConsumptions(result);
  
      } catch (err) {
        console.error("Error fetching Consumption For Nema and Pillars:", err);
      }
    };;

    const getLatestPayloads = async () => {
        try {
            const result = await apiCallsDashboard.Actions.GetLatestPayloads();
            const mappedLatestPayloads = result.map(latestPayload =>({
              device: latestPayload[0] || "Μη Διαθέσιμα Δεδομένα",
              state: latestPayload[1] || "Μη Διαθέσιμα Δεδομένα",
              port: latestPayload[2] || "Μη Διαθέσιμα Δεδομένα",
              date: latestPayload[3] || "Μη Διαθέσιμα Δεδομένα",
            }))
            setLatestPayloads(mappedLatestPayloads);
        }
        catch (err) {
            console.error("Error fetching latestPayloads");
        }
    }

    const getGatewaysInfo = async () => {
        try {
          const result = await apiCallsDashboard.Actions.GetgatewaysInfo();
          setGateways(result);
          const mappedGateways = result.map(gateway => ({
            gateway: gateway[0].gatewayName || "N/A",
            state: gateway[0].coordinates == [0,0] ? 'Disconnected' : 'Connected'
          }));
      
          setGatewaysInfo(mappedGateways);

          const connectedGateways = mappedGateways.filter(gateway => gateway.state === 'Connected').length;
          const disconnectedGateways = mappedGateways.filter(gateway => gateway.state === 'Disconnected').length;
          setGatewaysStatus([connectedGateways,disconnectedGateways]);
        } catch (err) {
          console.error("Error fetching gateways info:", err);
        }
    };

    useEffect(() => {
        getTotalConsumptionForNEMAAndPillars(filters);
        getCountsDevices();
        getGatewaysInfo();
        getLatestPayloads();

    }, []);
  
    const handleSearchClick = () => {
        getTotalConsumptionForNEMAAndPillars(filters);
    }
  
    return { countDevices, gateways, gatewaysInfo,totalConsumptions, latestPayloads, gatewaysStatus, devicesStates, handleSearchClick };
};